import { useEntityContext } from "../useEntityContext";
import { useEntityTabs } from "../components/TabbedEntityPage";
import { History, HistoryComponent } from "../History";
import { EntityScreen } from "./components/layout/Screen";
import { HeaderPanel } from "./components/layout/HeaderPanel";
import { SummaryPanel } from "./components/layout/SummaryPanel";
import { InsightsPanel } from "./components/layout/InsightsPanel";
import { EntityTabs } from "./components/EntityTabs";
import { useMessageAttributes, useMessageInsights } from "./MessageEntity";
import { PullRequestReviewComment } from "../overviews/PullRequestReviewComment";

export const PullRequestReviewCommentEntity = () => {
  const context = useEntityContext();
  const entity = context.dataRef.current.entity;

  const insights = useMessageInsights(entity);
  const attributes = useMessageAttributes(entity);

  const { name, body, PullRequest } = entity.properties;
  return (
    <EntityScreen
      headerPanel={
        <HeaderPanel label={name} entity={entity} attributes={attributes} />
      }
      summaryPanel={
        <SummaryPanel title={PullRequest.value} description={body} />
      }
      insightsPanel={<InsightsPanel cards={insights} />}
    >
      <EntityTabs
        entity={entity}
        propertiesSkipList={["name", "pullRequestTitle", "authorName", "Age"]}
        tabs={useEntityTabs({
          entity,
          others: [
            {
              name: "Comment Overview",
              component: (
                <PullRequestReviewComment
                  entity={context.dataRef.current.entity}
                />
              ),
            },
          ],
          history: (
            <History>
              <HistoryComponent />
            </History>
          ),
        })}
      />
    </EntityScreen>
  );
};
